<template>
<div>
<ContentHeader :title="$store.state.languages.lang_phrases.yeni_marka_ozel_nitelik_grubu"  url="BrandCustomAttributes" :show_button="true"  icon="arrow-left" buttontype="danger" :label="$store.state.languages.lang_phrases.geri_don"></ContentHeader>


<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="!loading">
<form @submit.prevent="submitForm" class="mt-4">
<div class="grid">

<div class="col-12">
<InputTextValidate :data="fields[0]" :fieldindex="0" @emitValue="inputValueEmitted"></InputTextValidate>
</div>


</div>

<div class="flex justify-content-end flex-wrap mt-3">
 <Button :label="$store.state.languages.lang_phrases.kaydet" class=" p-button-primary p-button-outlined  p-button-sm" :loading="$store.state.ui.submitting" type="submit"></Button>
</div>


</form>
</template>

</div>
</template>

<script>
export default {

  name: 'CreateBrandCustomAttributeGroup',

  data () {
    return {
    	loading:true, 
    	fields:[
	      {
	        title:"İsim",
	        key:"name",
	        type:"text",
	        value:null,
	        min_length:2,
	        max_length:250,
	        is_required:true,
	        has_error:false,
	        error_message:null,
	        show:true,
	      },
      ]

    }
  },
  computed:{
    preflang_id()
    {
      return this.$store.state.auth.user.preflang_id
    }
  },
  watch:
  {
    preflang_id()
    {
      setTimeout(()=>{
        this.fields[0].title = this.$store.state.languages.lang_phrases.isim
      },500)      
    }
  },
  mounted()
  {
  	this.loading=false
  },
  methods:{
  	submitForm()
    {
        let validated = this.validateForm(this.fields)
        if(!validated.has_error)
        {
          this.submit()
        }
    },
    inputValueEmitted(data)
    { 
      this.fields[data.index].value = data.value 
      this.fields[data.index].has_error = false  
    },
    submit()
    {         

      let formdata = this.createFormData(JSON.parse(JSON.stringify(this.fields)))
      
      formdata.append("brand_id",this.$route.params.id)    
      //formdata.append("data",JSON.stringify(this.fields))
      this.generalSubmission(formdata,"custom_attribute/store_group",this.afterSubmit)
    },
    afterSubmit(response)
    {
    	console.log(response.data)
    	this.$router.push({ name: 'BrandCustomAttributeGroup', params: { group_id:response.data.id } }) 
      
    },

  }
}
</script>

<style lang="css" scoped>
</style>